import { render } from "./wManagementStructure.vue?vue&type=template&id=797ddd74&ts=true"
import script from "./wManagementStructure.vue?vue&type=script&lang=ts"
export * from "./wManagementStructure.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__